import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { HomeService } from '../../../../services/home.service';
import { Observable } from 'rxjs/internal/Observable';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { SuppliesService } from '../../../../services/supplies';

@Component({
  selector: 'app-supplyinvoice',
  templateUrl: './supplyinvoice.component.html',
  styleUrl: './supplyinvoice.component.scss'
})
export class SupplyinvoiceComponent {
  data!: any;
  invoiceId!: any;
  date!: any;
  note!: any;
  supplier_name!: any;
  products!: any;
  qty!: any;
  prices!: any;
  sumprices!: any;
  contentReady: boolean = true;
  isMobile: boolean = false;
  translocoList: any = [];
  constructor(private _router: Router,
    private _profileService: ProfileService,
    private _suppliesService: SuppliesService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.contentReady = true;
    this.isMobile = this.deviceService.isMobileDevice();

    this.route.queryParams.subscribe(params => {
      const id = params['id'];

      if (!id) {
        console.warn('⚠️ No supply id in query params');
        return;
      }

      this.invoiceId = +id;
      this.loadSupply();
    });
  }

  loadSupply() {
    this._suppliesService.getSupplyById(this.invoiceId).subscribe({
      next: (res) => {
        // res هو الـ Supply اللي راجع من show()
        this.data = res;
        console.log('Supply => ', res);

        // note
        this.note = res.note && res.note != "undefined" ? res.note : 'no note';

        // created_at
        this.date = this.convertDate(res.created_at);

        this.supplier_name = res.supplier_name;

        // على حسب أسماء الأعمدة عندك في جدول supplies
        this.qty = String(res.new_qtys).split(',');
        this.prices = String(res.new_price).split(',');
        this.products = String(res.items).split(',');

        this.sumprices = this.sumArray(this.prices);

        this.contentReady = false;
      },
      error: (err) => {
        console.error('Error loading supply invoice', err);
        this.contentReady = false;
      }
    });
  }

  sumArray(array: any[]): number {
    let fixedArray = [];
    for (let i = 0; i < array.length; i++) {
      // Assuming 'array' is an array of objects, e.g., [{ price: '10', qty: '2' }, ...]
      fixedArray.push(parseInt(this.prices[i]) * parseInt(this.qty[i])); // Assuming `price` and `qty` are properties of the objects
    }

    // Sum the values and return the total
    return fixedArray.reduce((sum: number, value: number) => sum + value, 0);
  }
  convertDate(dateString: any) {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  createList(e: any) {
    this.translocoList.push(String(e));
    console.log(this.translocoList)
  }
}
